import React from "react";
import { format } from "date-fns";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { EmptyState } from "@design-system/EmptyState/EmptyState";

interface NoMatchingTransactionsProps {
    onResetFilters: () => void;
    bookkeepingStartDate: Date | null;
}

export const NoMatchingTransactions: React.FC<NoMatchingTransactionsProps> = ({
    onResetFilters,
    bookkeepingStartDate,
}) => {
    let header: string;
    if (bookkeepingStartDate) {
        const formattedDate = format(
            bookkeepingStartDate,
            fullDateFullYearFormat,
        );
        header = `No matching transactions since bookkeeping historical cutoff ${formattedDate}.`;
    } else {
        header = "No matching transactions";
    }

    return (
        <EmptyState
            header={header}
            ctaText="Clear filters"
            action={onResetFilters}
            emphasizeHeader
        />
    );
};
